import { isInternational } from './_checkForInternational';

const enableMainDropdownMenu = (response) => {
	const superCategories = response.superCats;
	superCategories.map((thisSuperCat) => {
		let columns = thisSuperCat.columns;
		let thisSuperCatName = thisSuperCat.display;
		let linkElement = document.querySelector(`[data-display=${CSS.escape(thisSuperCatName)}]`);
		let linkParent, lastChild;
		if (linkElement !== null && linkElement.parentElement.style.display !== 'none') {
			linkParent = linkElement.parentElement;
			lastChild = linkParent.lastElementChild;
		}
		let dropdownHTML = '';
		if (linkParent !== undefined && columns !== undefined && columns.length > 0) {
			let megaMenuWrapper = document.createElement('div');
			megaMenuWrapper.classList.add('row', 'mega-menu-wrapper');
			linkParent.insertBefore(megaMenuWrapper, lastChild);
			dropdownHTML += '<div class="megaMenuCloseWrapper"><button class="megaMenuClose" type="button">&times;</button></div>';
			columns.forEach((column) => {
				dropdownHTML += '<div class="col"><ul class="children">';
				let groupings = column.groupings;
				if (groupings.length > 0) {
					groupings.forEach((group) => {
						dropdownHTML += '<li><a class="superCat" href="' + group.link + '" manual_cm_sp="' + group.manual_cm_sp + '">' + group.display + '</a></li>';
						if (group.items.length > 0) {
							let listitems = group.items;
							listitems.forEach((item) => {
								dropdownHTML += '<li><a href="' + item.link + '" manual_cm_sp="' + item.manual_cm_sp + '">' + item.display + '</a></li>';
							});
						}
					});
				}
				dropdownHTML += '</ul></div>';
			});
			megaMenuWrapper.innerHTML = dropdownHTML;
		}
	});

	var $mainNavUlLi = $('#main-nav ul li');
	var $mainNavHiddenButtons = $('#main-nav .hiddenButtonForNav');
	var ddDelay;
	if ($('.desktopPage').length > 0) {
		$mainNavUlLi
			.mouseenter(function () {
				$('#main-nav .hiddenButtonForNav').each(function () {
					$(this).attr('aria-expanded', false);
				});
				$('.megaMenuClose').each(function () {
					$(this).css('visibility', 'hidden');
				});
				$(this).find('a').attr('aria-expanded', true);
				// $(this).find('.hiddenButtonForNav').attr('aria-expanded', true);
				var hoveredOn = this;
				if ($('.activeMenu').length == 0) {
					ddDelay = setTimeout(function () {
						if ($(hoveredOn).find('i, div.row').children().length > 0) {
							$(hoveredOn).find('i, div.row').not('.do-hide').addClass('activeMenu').css('display', 'flex');
						}
					}, 200);
				}
				//11673 Supercategory Dropdown showing background cursor
				$('input').trigger('blur');
			})
			.mouseleave(function () {
				$(this).find('a').attr('aria-expanded', false);
				$(this).find('.hiddenButtonForNav').attr('aria-expanded', false);
				clearTimeout(ddDelay);
				$(this).find('i, div.row').hide();
				$(this).find('i, div.row').removeClass('activeMenu');
			});
		// www 16607 ADA keyboard navigation
		$mainNavHiddenButtons.on('click', function () {
			var menu = this.previousElementSibling;
			var link = menu.previousElementSibling;
			var menuActive = $('.activeMenu').length;
			var wasopen = link.getAttribute('aria-expanded');
			var menuCloseButton = $('.megaMenuClose');
			if (menuActive > 0) {
				$('.activeMenu').each(function () {
					$(this).hide();
					$(this).removeClass('activeMenu');
				});
				$('.superCatLink > a').each(function () {
					$(this).attr('aria-expanded', false);
				});
				$('#main-nav .hiddenButtonForNav').each(function () {
					$(this).attr('aria-expanded', false);
					$(this).removeClass('hiddenSelected');
				});
			}

			if (link.getAttribute('aria-expanded') && link.getAttribute('aria-expanded') == 'true') {
				link.setAttribute('aria-expanded', false);
				menu.style = 'display: none;';
				menu.classList.remove('activeMenu');
			} else if (wasopen == 'false' || wasopen == null) {
				link.setAttribute('aria-expanded', true);
				menu.classList.add('activeMenu');
				menu.style = 'display: flex;';
				this.setAttribute('aria-expanded', true);
				this.classList.add('hiddenSelected');
				$('.mega-menu-wrapper.activeMenu .megaMenuClose').css('visibility', 'visible');
				$('.mega-menu-wrapper.activeMenu .megaMenuClose').trigger('focus');
			}
			//11673 Supercategory Dropdown showing background cursor
			$('input').trigger('blur');
		});

		if ($('.desktopPage').length > 0) {
			$('.mega-menu-wrapper').on('keydown', function (e) {
				var activeMenu = this;
				var focusableElements = document.querySelectorAll('.mega-menu-wrapper.activeMenu a');
				var lastFocusable = focusableElements[focusableElements.length - 1];
				var currentHiddenNav = document.querySelector('.hiddenSelected');
				var menuCloseButton = document.querySelector('.mega-menu-wrapper.activeMenu .megaMenuClose');

				if (e.key === 'Enter' && document.activeElement == menuCloseButton) {
					currentHiddenNav.focus();
					currentHiddenNav.classList.remove('hiddenSelected');
					activeMenu.previousElementSibling.setAttribute('aria-expanded', false);
					menuCloseButton.style.visibility = 'hidden';
					activeMenu.style.display = 'none';
					e.preventDefault();
				}

				if (e.key === 'Escape') {
					currentHiddenNav.focus();
					currentHiddenNav.classList.remove('hiddenSelected');
					activeMenu.previousElementSibling.setAttribute('aria-expanded', false);
					menuCloseButton.style.visibility = 'hidden';
					activeMenu.style.display = 'none';
				}

				if (e.shiftKey && e.keyCode == 9 && document.activeElement == menuCloseButton) {
					currentHiddenNav.focus();
					currentHiddenNav.classList.remove('hiddenSelected');
					activeMenu.previousElementSibling.setAttribute('aria-expanded', false);
					menuCloseButton.style.visibility = 'hidden';
					activeMenu.style.display = 'none';
					e.preventDefault();
				}

				if (e.key === 'Tab' && document.activeElement == lastFocusable) {
					menuCloseButton.focus();
					e.preventDefault();
				}
			});
		}
		// www 16607 ADA keyboard navigation
	} else {
		const hideActiveMenu = () => {
			$('.activeMenu').each(function () {
				$(this).hide();
				$(this).removeClass('activeMenu');
			});
		};
		$(document).on('touchstart', function (e) {
			if ($('.activeMenu').length > 0) {
				var container = $('#main-nav ul');
				if (!container.is(e.target) && container.has(e.target).length === 0) hideActiveMenu();
			}
		});
		$('#main-nav ul li').on('touchstart', function (e) {
			//11673 Supercategory Dropdown showing background cursor
			$('input').trigger('blur');
			if (!$('#main-nav .children li').has(e.target).length > 0) e.preventDefault();
		});
		$('#main-nav ul li a')
			.not('#main-nav .children li a')
			.on('touchstart', function (e) {
				e.preventDefault();
				if ($(this).next('div.row').hasClass('activeMenu') || $(this).next('div.row').children().length == 0) {
					var _link = $(this).attr('href');
					window.location.href = _link;
				} else if ($('.activeMenu').length > 0) hideActiveMenu();
				if ($(this).next('div.row').children().length > 0) {
					$(this).parents('li').find('div.row').not('.do-hide').addClass('activeMenu');
					$(this).parents('li').find('div.row').css('display', 'flex');
				}
			})
			.on('dblclick', function (e) {
				e.preventDefault(); //cancel system double-click event
			});
	}
};

export { enableMainDropdownMenu };
